import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Button from "../../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
// import { memberActions } from "../../../../_store/Admin/members.slice";
import editIcon from "../../../assets/svg/edit-icon.svg";
import CustomLoader from "../../../components/common/ui/Loader";
import TextInput from "../../../components/common/ui/Inputs/TextInput";
import { history } from "../../../_helpers/history";
import { committeeActions } from "../../../_store/committee.slice";
import warningIcon from "../../../assets/constant-contact-warning.png";

function CommitteePageIntegration() {
  const dispatch = useDispatch();
  const { committeeForm, committeeList, loading } = useSelector(
    (x) => x?.committee,
  );
  const { ActiveStatus } = useSelector((x) => x?.dropDown);
  const list = committeeList?.data?.committees;
  const totalCount = committeeList?.data?.totalItems || 0;
  const [filters, setFilters] = useState({
    committeeName: "",
    status: true,
  });
  const [apiParams, setApiParams] = useState(
    `?page=${1}&limit=${10}&status=${true}`,
  );
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);

  const columns = [
    {
      name: "Committee Name",
      key: "committeeName",
      selector: (row) => row.committeeName,
      sortable: true,
      width: "272px",
    },
    // {
    //   name: "Committee Chair",
    //   key: "committeeAdmin",
    //   selector: (row) =>
    //     row.committeeAdmin?.firstName + " " + row.committeeAdmin?.lastName,
    //   sortable: true,
    //   width: "272px",
    // },
    // {
    //   name: "Committee Chair",
    //   key: "committeeAdmin",
    //   selector: (row) => {
    //     if (
    //       Array.isArray(row.committeeAdmin) &&
    //       row.committeeAdmin.length > 0
    //     ) {
    //       const first = `${row.committeeAdmin[0].firstName} ${row.committeeAdmin[0].lastName}`;
    //       return row.committeeAdmin.length > 1 ? `${first} , ...` : first;
    //     }
    //     return "-";
    //   },
    // },
    {
      name: "Committee Chair",
      key: "committeeAdmin",
      selector: (row) => {
        if (
          Array.isArray(row?.committeeAdmin) &&
          row?.committeeAdmin?.length > 0
        ) {
          const firstMember = row?.committeeAdmin[0];
          const first = `${firstMember?.firstName} ${firstMember?.lastName}`;

          return row?.committeeAdmin?.length > 1 ? (
            <div
              title={row?.committeeAdmin
                .map((member) => `${member?.firstName} ${member?.lastName}`)
                .join(", ")}
            >
              {first} , ...
            </div>
          ) : (
            first
          );
        }
        return "-"; // fallback when committeeAdmin is empty or undefined
      },
    },
    {
      name: "Status",
      key: "lastName",
      selector: (row) => (row.status ? "Active" : "Inactive"),
      sortable: true,
    },
    {
      width: "80px",
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleEditCommittee(row);
            }}
          />
          {row?.ccIsVerified === false && (
            <div className="d-flex gap-2">
              <img
                src={warningIcon}
                title="This committee is not added in CC. Please reconnect CC and update to reflect the changes"
                alt="warning-icon"
                aria-hidden="true"
                className="sbpc-icon-size"
              />
            </div>
          )}
        </div>
      ),
      sortable: false,
    },
  ];

  const handleEditCommittee = (row) => {
    history?.navigate(`/Admin/CommitteePage/${row?._id}`, {
      state: { committee: row },
    });
  };
  // useEffect(() => {
  //   const query = new URLSearchParams({
  //     page: "1",
  //     limit: "10",
  //     ...Object.fromEntries(
  //       Object.entries(filters).filter(([_, v]) => v !== "")
  //     ),
  //   }).toString();

  //   setApiParams(`?${query}`);
  // }, [filters]);

  useEffect(() => {
    const params = apiParams;
    dispatch(committeeActions?.getCommitteeList(params));
  }, [apiParams, dispatch]);

  const buildQuery = () => {
    return new URLSearchParams({
      page: "1",
      limit: "10",
      ...Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== ""),
      ),
    }).toString();
  };

  const handleSearchChange = (e) => {
    const { name, value, type } = e.target;
    const sanitizedValue = typeof value === "string" ? value.replace(/^\s+/, "") : value;
    setFilters((prev) => ({
      ...prev,
      [name]: type === "radio" ? (sanitizedValue === "true" ? true : false) : sanitizedValue,
    }));
  };

  // const handleRowPerPage = (page) => {
  //   const updatedParams = apiParams.replace(/&limit=\d+/, `&limit=${page}`);
  //   setApiParams(updatedParams);
  //   setRowCountPerPage(page);
  //   setPageNo(1);
  // };

  const handleRowPerPage = (pageSize) => {
    const query = new URLSearchParams({
      page: "1",
      limit: pageSize,
      ...Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== ""),
      ),
    }).toString();

    setApiParams(`?${query}`);
    setRowCountPerPage(pageSize);
    setPageNo(1);
  };

  const handlePageChange = (Pno) => {
    let updatedParams;
    if (/(&|\?)page=\d+/.test(apiParams)) {
      // if page param exists, replace it
      updatedParams = apiParams.replace(/(&|\?)page=\d+/, `$1page=${Pno}`);
    } else {
      // if no page param, append it
      updatedParams = apiParams.includes("?")
        ? `${apiParams}&page=${Pno}`
        : `?page=${Pno}`;
    }

    setApiParams(updatedParams);
    setPageNo(Pno);
  };

  const handleSearchSubmit = (e) => {
    console.log(filters);
    e?.preventDefault();
    const query = `?${buildQuery()}`;
    setApiParams(query);
    setPageNo(1);
    setRowCountPerPage(10);
    dispatch(committeeActions?.getCommitteeList(query));
    // dispatch(committeeActions?.getCommitteeList(apiParams));
  };

  const handleFormReset = (e) => {
    e?.preventDefault();
    setFilters({
      committeeName: "",
      status: true,
    });
    const params = `?page=${1}&limit=${10}&status=${true}`;
    setApiParams(params);
    setPageNo(1);
    setRowCountPerPage(10);
    dispatch(committeeActions?.getCommitteeList(params));
  };

  if (loading) return <CustomLoader />;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">Committee</h1>
      </div>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
          Search Committee
        </h1>
        <form
          className="p-3 row"
          onSubmit={(e) => {
            handleSearchSubmit(e);
          }}
          onReset={(e) => {
            handleFormReset(e);
          }}
        >
          <div className="col-md-3">
            <TextInput
              label="Name"
              placeholder="Committee name"
              name="committeeName"
              handleChange={handleSearchChange}
              value={filters?.committeeName}
            />
          </div>
          {/* <div className="col-md-3">
            <RadioInput
              name="status"
              id="status"
              label="Status"
              options={ActiveStatus}
              handleChange={(e) => handleSearchChange(e)}
              selectedValue={filters?.status}
            />
          </div> */}

          <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
            <Button status="secondary" label="Search" type="submit" />
            <Button status="reset" label="Reset" type="reset" />
          </div>
        </form>
      </div>

      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color p-3 ">Committee List</h1>
        <Table
          columns={columns}
          data={list}
          pagination
          onChangeRowsPerPage={handleRowPerPage}
          onChangePage={handlePageChange}
          totalRowCount={totalCount}
          currentPage={pageNo}
          paginationPerPage={rowCountPerPage}
        />
      </div>
    </>
  );
}

export default CommitteePageIntegration;
